<template lang='pug'>
//- 設定通知信箱區塊
div(:class='$style[`cc-popbox-set-mail`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap 設定
        span.font-doctor-theme 通
        span.font-normal-theme 知
        span.no-wrap 信箱
      div(:class='$style[`cc-content-title-tips`]') 您是透過手機、LINE註冊登入，如果想接收預防、嚴重化提醒請完成信箱設定。

    Inputer(
      title='設定信箱'
      v-model.trim='formConfig.emailValue'
      :defaultValue='loginStatus ? loginProfile.email : ``'
      :class='$style[`cc-content-new-input`]'
      :resetButton='false'
      :placeholder='`您的信箱`'
      :beforeIcon='`mail`'
      :beforeIconSize='24'
      :beforeIconColor='`#d0d0d0`'
      :type='`email`'
      :errorRegex='formConfig.emailRegexError'
      :errorRegexInfo='formConfig.emailErrorLog'
      :errorValue='formConfig.emailError'
      :keyPressEnter='handleCheckProgressBeforeLogin'
      @clearErrorMsg="(value) => {this.formConfig.emailError = value[0]; this.formConfig.emailRegexError = value[1]; this.showErrorMsg = false;}")

    div(:class='$style[`cc-content-controller`]')
      button(
        title='送出'
        tabindex='0'
        aria-label='送出'
        :class='[$style[`cc-content-new-send`], $style[!this.formConfig.emailValue ? `cc-content-disabled` : ``]]'
        @click='handleCheckProgressBeforeLogin')
        IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
        span {{ showLoading ? `` : `送出`}}

      button(
        title='忽略'
        tabindex='0'
        aria-label='忽略'
        :class='$style[`cc-content-new-ignore`]'
        @click='handleClosePopBox')
        span 忽略


</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions, mapMutations } from 'vuex';

import Inputer from '../common/Input';
import IconLoading from '../../icon/Loading';

import {
  // putDjangoAllTypeMember,
  putUniqueDoctor,
  putUniqueNormal,
  putEditUserAccount,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    IconLoading,
  },

  data() {
    return {
      showLoading: false,

      formConfig: {
        emailValue: '',
        emailRegexError: false,
        emailErrorLog: '',
        emailError: false,
      },
      verifyAllPass: true,
      showErrorMsg: false,
    };
  },

  // created() {
  // },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    ...mapActions({
      userUpdateProfile: 'user/userUpdateProfile',
    }),

    handleClosePopBox() {
      this.changePopBoxStatus({
        active: false,
        include: '',
      });
    },

    handleFormsCheckToPass() {
      this.verifyAllPass = this.$options.data().verifyAllPass;
      const emailPattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

      if (this.formConfig.emailValue) {
        if (!this.formConfig.emailValue.match(emailPattern)) {
          this.formConfig.emailRegexError = true;
          this.formConfig.emailError = true;
          this.formConfig.emailErrorLog = '格式錯誤(範例: mail@cancell.ai)';
          this.verifyAllPass = false;
        }
      } else {
        // 信箱為空
        this.formConfig.emailError = true;
        this.verifyAllPass = false;
      }
    },

    handleConnectDjangoWithApi() {
      // IF Verify On Error, Return
      if (!this.verifyAllPass) { return; }
      this.showLoading = true;
      this.updateAccountProfile(this.loginProfile.user_type);

      // (查詢密碼 Auth Step-1) 確認有無Email帳號
      // putDjangoAllTypeMember(`?oauth=${this.formConfig.emailValue}`)
      //   .then((res) => {
      //     if (!res.data.count) {
      //       console.log('查詢密碼 Auth Step-1:: 核對有無Email帳號，Pass!');
      //       this.updateAccountProfile(this.loginProfile.user_type);
      //     } else {
      //       console.log('查詢密碼 Auth Step-1:: 核對有無Email帳號，Failed!');
      //       this.showLoading = false;
      //       this.formConfig.emailError = true;
      //       this.formConfig.emailErrorLog = '信箱已被使用';
      //     }
      //   })
      //   .catch((/* error */) => {
      //     this.showLoading = false;
      //   });
    },

    processAfterUpdateConfirm() {
      this.showLoading = false;

      let userProfile = this.loginProfile;
      userProfile['email'] = this.formConfig.emailValue;
      this.userUpdateProfile(userProfile);

      this.changePopBoxStatus({
        active: true,
        include: 'updateConfirm',
      });

      setTimeout(() => {
        this.changePopBoxStatus({
          active: false,
          include: '',
        });
      }, this.POP_DURATION);
    },

    updateAccountProfile(userType) {
      switch (userType) {
        case 'doctor':
          axios.all([
            putUniqueDoctor('', {
              email: this.formConfig.emailValue,
              hashcode: this.loginHashCode,
            }),
            putEditUserAccount(`/?hashcode=${this.loginHashCode}`, {
              auth_id: `${this.loginDjangoId}`,
              oauth: this.loginProfile.oauth,
              phone: this.loginProfile.phone,
              email: this.formConfig.emailValue,
            }, {
              headers: {
                'content-Type': 'application/json',
                // Authorization: `Bearer ${jwtAccess}`,
              }
            })])
            .then(axios.spread((data1, data2) => {
              this.processAfterUpdateConfirm();
              console.log('UPDATE');
            }))
            .catch((error) => { console.log('一般個人資料頁，更新失敗', error.response); })
          break;

        case 'normal':
          axios.all([
            putUniqueNormal('', {
              email: this.formConfig.emailValue,
              hashcode: this.loginHashCode,
            }),
            putEditUserAccount(`/?hashcode=${this.loginHashCode}`, {
              auth_id: `${this.loginDjangoId}`,
              oauth: this.loginProfile.oauth,
              phone: this.loginProfile.phone,
              email: this.formConfig.emailValue,
            }, {
              headers: {
                'content-Type': 'application/json',
                // Authorization: `Bearer ${jwtAccess}`,
              },
            })])
            .then(axios.spread((data1, data2) => {
              this.processAfterUpdateConfirm();
              console.log('UPDATE');
            }))
            .catch((error) => { console.log('一般個人資料頁，更新失敗', error.response); })
          break;

        default:
          break;
      }
    },

    async handleCheckProgressBeforeLogin() {
      await this.handleFormsCheckToPass();
      await this.handleConnectDjangoWithApi();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // authJwtToken: 'user/exportUserJwtToken',
      loginHashCode: 'user/exportUserHashCode',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popSetMail.scss';
</style>
